<template>
  <div style="margin-top:10px">     
    <flickity class="flickity" ref="flickity" :options="flickityOptions">
    <div v-for="(img) in marcas" v-bind:key="img._id" class="carousel-cell" :style="{'width': `${altura_carousel} !important`}">
      <v-img style="max-width:171px; max-height:104px; width:100%; height:100%; background: #e0e0e0;" :src="img.url_imagen" alt="" @click="ver_marca(img)"></v-img>
    </div>            
  </flickity>  
  </div>    
</template>

<script>
import Flickity from "vue-flickity";

export default {
    props:{
        marcas: Array,
    },
    components: {
        Flickity,
    },  
    data() {
        return {        
          imagenes: [],
          flickityOptions: {
            initialIndex: 5, //5
            prevNextButtons: true,
            pageDots: true,        
            freeScroll: false,
            autoPlay: true,        
            groupCells: 5,  //5
            cellAlign: 'center'
          }  
        };
    },    
   created () {
     if(this.$vuetify.breakpoint.name == 'xs' || this.$vuetify.breakpoint.name == 'sm'){
            this.flickityOptions.initialIndex = 2
            this.flickityOptions.groupCells = 2
         }else{
            this.flickityOptions.initialIndex = 5
            this.flickityOptions.groupCells = 5
         }
         console.log("this.flickityOptions",this.flickityOptions)
    },
    computed: {         
        altura_carousel () {
          let dimension;
          switch (this.$vuetify.breakpoint.name) {
            case 'xs': 
              dimension = '160px'
            break;
            case 'sm': 
              dimension ='160px'
            break
            case 'md': 
              dimension = '260px'
            break
            case 'lg': 
              dimension = '260px'
            break;
            case 'xl':
              dimension = '260px'
            break;
          }          
          return dimension
        },
    },
    methods:{
        ver_marca(item){
            this.$emit('update_modal_marcas', item)            
        }
    }
};
</script>
<style>
/*260*/
/*200*/
.carousel-cell {  
  height: 104px;
  margin-right: 10px;  
  counter-increment: gallery-cell;
}
</style>